<template>
    <div class="bar">
        <div class="title-bar">
            <span class="title">다음 구매 예상일</span>
            <div class="icon-wrapper" @click.stop="showTooltip = !showTooltip">
                <img class="icon-img" src="../../assets/warning_icn.png" alt="안내" />
                <div v-if="showTooltip" class="tooltip">
                <div class="tooltip-arrow"></div>
                <span><span style="font-weight: 600;">솔닥 결제 기준으로 계산한 날짜예요.</span><br>정확한 날짜는 공단 문자로 확인해 주세요.</span>
                </div>
            </div>
        </div>

        <div class="scroll-content" v-if="count > 1">
            <div v-if="profile.expected_purchase_date !== null" :key="`item_${index}`" class="item" v-for="(profile, index) in profileData" >
                <div class="row">
                    <span class="item-name">{{ profile.name }}</span>
                    <span :class="(getDday(profile.expected_purchase_date).indexOf('+') > -1) ? 'item-dday-plus': 'item-dday' ">{{ getDday(profile.expected_purchase_date) }}</span>                    
                </div>
                <div class="row">
                    <span class="item-label">구매 예상일</span>
                    <span class="item-datetime">{{ convertDateTimeToString(profile.expected_purchase_date) }}</span>
                </div>
            </div>
        </div>
        <div class="scroll-content2" v-if="count === 1">
            <div class="item2" v-if="oneProfile.expected_purchase_date !== null">
                <div class="row">
                    <span class="item-name">{{ oneProfile.name }}</span>
                    <span :class="getDday(oneProfile.expected_purchase_date).indexOf('+') > -1 ? 'item-dday-plus': 'item-dday' ">{{ getDday(oneProfile.expected_purchase_date) }}</span>                    
                </div>
                <div class="row">
                    <span class="item-label">구매 예상일</span>
                    <span class="item-datetime">{{ convertDateTimeToString(oneProfile.expected_purchase_date) }}</span>
                </div>
            </div>
        </div>
        <div class="no-data" v-if="count === 0">
            솔닥을 이용하시면 다음 구매 시점을 쉽게 관리할 수 있어요!
        </div>
    </div>
</template>

<script>
import Convert from '@/utilities/convert'

export default{
    name: 'dDayList',
    props: ['profileData'],
    data: function()
    {
        return {
            showTooltip: false,
            count: 0,
            oneProfile: null
        }
    },
    mounted() {
        this.checkData(this.profileData)
        
        //체크 필요 
        document.addEventListener('click', this.handleClickOutside)
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleClickOutside)
    },
    methods: {
        checkData: function(data)
        {
            if(data === null)
            {
                this.count = 0;
            }
            this.count = 0;
            for(var i = 0; i < data.length; i++)
            {
                if(data[i].expected_purchase_date !== null)
                {
                    this.count = this.count + 1;
                    this.oneProfile = data[i]
                    // return false;
                }
            }
        },
        handleClickOutside(e) {
           
            this.showTooltip = false
            
        },
        getDday: function (dateString) {
            const inputDate = new Date(dateString)
            const today = new Date()

            // 날짜만 비교하기 위해 시·분·초 초기화
            inputDate.setHours(0, 0, 0, 0)
            today.setHours(0, 0, 0, 0)

            const diffTime = inputDate - today
            const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24))

            if (diffDays === 0) {
                return 'D-Day'
            } else if (diffDays > 0) {
                return `D-${diffDays}`
            } else {
                return `D+${Math.abs(diffDays)}`
            }
        },
        convertDateTimeToString: function(datetime)
        {
            return Convert.convertTimeStampToStringDate(datetime)
        }
    }
}
</script>
  
<style scoped>
/* 1. 스크롤바 전체 */
::-webkit-scrollbar {
  height: 8px;
}

/* 2. 스크롤바 트랙 (배경) */
::-webkit-scrollbar-track {
  background: var(--gray-30-stroke, #E8EAEE);;
  border-radius: 4px;
}

/* 3. 스크롤바 핸들(움직이는 부분) */
::-webkit-scrollbar-thumb {
  background: #184FA1;
  border-radius: 4px;
}

/* 4. 스크롤바 핸들을 hover했을 때 */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.scroll-content {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    overflow-x: auto;
    white-space: nowrap;    
    box-sizing: border-box;
    padding: 16px 0;
    margin-bottom: 12px;
}
.scroll-content2 {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    white-space: nowrap;    
    box-sizing: border-box;
    padding: 16px 0;
    margin-bottom: 12px;
}
.row {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    width: 90%;
    height: 92px;
    margin-right: 8px;
    flex-shrink: 0; 
    border-radius: 6px;
    background: var(--Blue-04_Light-blue, #E5F0FC);
    box-sizing: border-box;
    padding: 16px;
}
.item2 {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
    height: 92px;
    margin-right: 8px;
    flex-shrink: 0; 
    border-radius: 6px;
    background: var(--Blue-04_Light-blue, #E5F0FC);
    box-sizing: border-box;
    padding: 16px;
}
.item-name {
    color: var(--Gray-100, #1E1E1E);
    font-family: Pretendard;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 122.222% */
}
.item-dday {
    color: #184FA1;
    text-align: right;
    font-family: Pretendard;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    background: var(--Gray-00, #FFF);
    padding: 0px 8px;
    box-sizing: border-box;
    height: 29px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.item-dday-plus {
    color: var(--Semantic-01_Orange, #FC7E2F);
    font-family: Pretendard;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    border-radius: 3px;
    background: var(--Gray-00, #FFF);
    padding: 0px 8px;
    box-sizing: border-box;
    height: 29px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.item-label {
    color: var(--Gray-60, #6B7684);
    font-family: Pretendard;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 122.222% */
}
.item-datetime {
    color: var(--Gray-100, #1E1E1E);
    font-family: Pretendard;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 122.222% */
}

@media (min-width: 600px) {
    .item {
        width: 500px;
    }
}
.icon-wrapper {
  position: relative;
  display: inline-block;
  cursor: pointer;
  margin-top: 6px;
  margin-left: 4px;
}

.icon-img {
  width: 22px;
}

.tooltip {
  position: absolute;
  left: 55%;
  top: 100%;
  transform: translateX(-55%);
  min-width: 276.5px;
  background: #234286;
  color: #fff;
  border-radius: 8px;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2px; /* 아이콘과 툴팁 간격 */
  box-sizing: border-box;
  color: var(--Gray-00, #FFF);
    font-family: Pretendard;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 133.333% */
    padding: 5px 8px;
}

.tooltip-arrow {
  position: absolute;
  top: -10px;
  left: 55%;
  transform: translateX(-55%);
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid #234286;
}

.title {
    color: var(--Gray-100, #1E1E1E);
    font-family: Pretendard;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
}
.bar {
    width: 100%;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    box-sizing: border-box;
    padding: 0 16px;
    background: #FFF;
}
.title-bar {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.no-data {
    width: 100%;
    height: 92px;
    display: flex;
    border-radius: 6px;
    background: var(--Gray-20, #F3F5F8);
    color: var(--Gray-60, #6B7684);
    font-family: Pretendard;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px; /* 122.222% */
    box-sizing: border-box;
    padding: 16px;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/molecules/DDayList.vue